import { formatDateDE } from '../time/format'
import { useAckVacationNotice, useVacation } from './useZeiten'

/** Zehnteltage → deutsche Tages-Anzeige („27,5"). */
export const tenthsToDays = (t: number): string => (t / 10).toLocaleString('de-DE', { maximumFractionDigits: 1 })

/**
 * Urlaubskonto-Karte („Meine Zeit", 2a): Rest groß, Anspruch + Übertrag klein — nur sichtbar, wenn der
 * Jahresanspruch gepflegt ist. Negativ = Warnstreifen (blockt nichts: der Chef sieht das Minus beim
 * Genehmigen). userId gesetzt → fremdes Konto (Chef-Sichten).
 */
export function VacationCard({ userId }: { userId?: number }) {
  const vac = useVacation(userId)
  const ack = useAckVacationNotice()
  if (!vac.data?.configured || !vac.data.account) return null
  const a = vac.data.account
  const negative = a.remainingTenths < 0
  return (
    <section className="wf-card" aria-label="Urlaubskonto">
      <h3 className="wf-card__title">Urlaub {vac.data.year}</h3>
      <p className={negative ? 'wf-vacation__rest wf-vacation__rest--neg' : 'wf-vacation__rest'}>
        <b>{tenthsToDays(a.remainingTenths)}</b> Tage übrig
      </p>
      <p className="sub">
        {tenthsToDays(a.entitlementTenths)} Tage Anspruch{a.prorated ? ' (anteilig — Eintritt im laufenden Jahr)' : ''}
        {a.carryTenths !== 0 ? `${a.carryTenths > 0 ? ' + ' : ' − '}${tenthsToDays(Math.abs(a.carryTenths))} Übertrag` : ''} · {tenthsToDays(a.consumedTenths)} genommen
      </p>
      {negative ? (
        <p className="wf-ztwarn" role="alert">
          <span aria-hidden="true">⚠</span>
          <span>Mehr Urlaub genommen als Anspruch — bitte mit dem Chef klären.</span>
        </p>
      ) : null}
      {vac.data.pendingNotice && userId == null ? (
        <div className="wf-ztwarn" role="alert">
          <span aria-hidden="true">🔔</span>
          <span>
            Hinweis deines Arbeitgebers vom {formatDateDE(vac.data.pendingNotice.sentAt.slice(0, 10))}: Du hattest noch{' '}
            {tenthsToDays(vac.data.pendingNotice.restTenths)} Tage Resturlaub für {vac.data.pendingNotice.year} — bitte nimm ihn
            rechtzeitig, sonst kann er zum 31.03.{vac.data.pendingNotice.year + 1} verfallen.
          </span>
          <button
            type="button"
            className="wf-btn wf-btn--ghost wf-btn--sm"
            onClick={() => ack.mutate(vac.data!.pendingNotice!.id)}
            disabled={ack.isPending}
          >
            Verstanden
          </button>
        </div>
      ) : null}
    </section>
  )
}

/** Kompakter Rest-Chip für den Genehmigungs-Posteingang — zeigt das Konto des ANTRAGSJAHRES
 *  (Review-Fund: Folgejahres-Planung im Herbst zeigte sonst das fast leere laufende Jahr). */
export function VacationRestChip({ userId, year }: { userId: number; year: number }) {
  const vac = useVacation(userId, year)
  if (!vac.data?.configured || !vac.data.account) return null
  return (
    <span className="wf-tag">
      Rest {vac.data.year}: {tenthsToDays(vac.data.account.remainingTenths)} Tage
    </span>
  )
}
